import Vue from 'vue'
import _ from 'lodash'

Vue.set(Vue.prototype, '_', _)



// WEBPACK FOOTER //
// ./resources/js/plugins/lodash.js